if (!customElements.get('social-feed-video')) {
  customElements.define('social-feed-video', class SocialFeedVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.modal = this.closest('social-feed');
      this.toggle = this.querySelector('[data-mute-toggle]');
      this._open = false;
      this._onToggle = this._onToggle.bind(this);

      if (this.toggle) this.toggle.addEventListener('click', this._onToggle);

      if (this.modal && this.video) {
        this.observer = new MutationObserver(() => this._sync());
        this.observer.observe(this.modal, {
          attributes: true,
          attributeFilter: ['hidden', 'aria-hidden', 'class'],
        });
        this._sync(); // handle the case where it's already open
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.toggle) this.toggle.removeEventListener('click', this._onToggle);
    }

    _isOpen() {
      const m = this.modal;
      if (!m) return false;
      if (m.getAttribute('aria-hidden') === 'true') return false;
      if (/\b(active|open|is-open|is-active)\b/.test(m.className)) return true;
      return !m.hasAttribute('hidden');
    }

    _sync() {
      const open = this._isOpen();
      if (open === this._open) return;
      this._open = open;
      open ? this.open() : this.close();
    }

    async open() {
      const v = this.video;
      try { v.currentTime = 0; } catch (e) {}
      v.muted = false;
      try {
        await v.play();
        this._reflect(false);
      } catch (e) {
        // Unmuted autoplay refused — fall back to muted and let the user tap to unmute
        v.muted = true;
        try { await v.play(); } catch (err) {}
        this._reflect(true);
      }
    }

    close() {
      const v = this.video;
      v.pause();
      v.muted = true;
      try { v.currentTime = 0; } catch (e) {}
      this._reflect(true);
    }

    _onToggle() {
      const v = this.video;
      v.muted = !v.muted;
      if (!v.muted && v.paused) v.play().catch(() => {});
      this._reflect(v.muted);
    }

    _reflect(muted) {
      this.classList.toggle('is-muted', muted);
      if (this.toggle) {
        this.toggle.setAttribute('aria-pressed', muted ? 'true' : 'false');
        this.toggle.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }
    }
  });
}